import { VALIDATION } from 'constant';
import { _t } from 'utils';
import { formField } from 'types';

export const nicFields = [
  formField.text({
    name: 'name',
    title: 'Name',
  }),
  formField.text({
    name: 'lan',
    title: _t('AUTO_SCALE.REPLICA_CONFIG.FIELDS.nics.lan'),
  }),
  formField.switch({
    name: 'dhcp',
    title: 'DHCP',
  }),
];

export const validations = [
  {
    name: 'name',
    type: VALIDATION.REQUIRED,
  },
  {
    name: 'lan',
    type: VALIDATION.REQUIRED,
  },
  {
    name: 'lan',
    type: VALIDATION.NUMBER,
    min: 1,
    max: 100,
  },
];
